import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IDesignerInputState, IDesignerKeyboardState } from './IDesignerInputState';

export function setKeyboardInputReducer(
  state: Draft<IDesignerInputState>,
  action: PayloadAction<IDesignerKeyboardState>,
) {
  state.keyboard = action.payload;
}
